export const MAJOR_APPLIANCE = 'MAJOR_APPLIANCE';
export const UNAVAILABLE = 'UNAVAILABLE';
export const OOS_ETA_UNAVAILABLE = 'OOS_ETA_UNAVAILABLE';
export const OOS_ALT_MODEL = 'OOS_ALT_MODEL';
export const BACK_ORDERED = 'BACK_ORDERED';
export const AVAILABLE = 'AVAILABLE';
export const ERROR = 'ERROR';
export const THD_AOL = 'THD_AOL';